<template>
  <v-layout row wrap justify-center fill-height>
    <v-layout row wrap justify-start fill-height style="max-width: 1440px">
      <v-flex xs12 v-if="err">
        <v-alert
            color="error"
            class="err"
            icon="warning"
            value="true"
            v-if="err">{{ err }}
        </v-alert>
      </v-flex>
      <v-flex xs12 md10 lg8 offset-lg1 class="section categories" pa-0>
        <v-flex class="text-xs-center" v-if="!loaded && !err">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-flex>
        <MenuCategories v-if="loaded && !err" :itemsList="catalogItems" />
      </v-flex>
      <div class="side-menu" :style="`top: ${stickyScrollDesktop}px;`" v-if="loaded && !err">
        <template v-for="(category, index) in catalogItems">
          <h3 class="px-2 cursorHand" v-if="category.name" :key="index" @click="selectedCat = category; $vuetify.goTo('#abc-'+category.itemId, options)">
            {{ category.name[$lang.current_lang] ? category.name[$lang.current_lang] : category.name.en }}
          </h3>
        </template>
      </div>
      <div class="scrolling-wrapper" :style="`top: ${stickyScrollMobile}px;background-color: ${goDark ? '#303030' : '#fafafa'}`" v-if="loaded && !err">
        <template v-for="(category, index) in catalogItems">
          <span class="px-2 cursorHand" v-if="category.name" :key="index" @click="selectedCat = category; $vuetify.goTo('#abc-'+category.itemId, options)">
            {{ category.name[$lang.current_lang] ? category.name[$lang.current_lang] : category.name.en }}
          </span>
        </template>
      </div>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    success: '',
    itemSuccess: '',
    err: '',
    loaded: false,
    catalogItems: null,
    pageYOffset: 0,
    duration: 800,
    easing: 'easeInOutCubic',
    selectedCat: null,
  }),
  computed: {
    ...mapGetters({
      company: 'company',
      width: 'width',
      goDark: 'goDark',
    }),
    stickyScrollDesktop() {
      if (this.pageYOffset > 170) return 10;
      return 170 - this.pageYOffset;
    },
    stickyScrollMobile() {
      if (this.pageYOffset > 150 && this.width >= 676 && this.width < 993) return 0;
      if (this.pageYOffset > 170 && this.width > 600 && this.width < 676) return 0;
      if (this.pageYOffset > 310 && this.width < 676) return 0;
      if (this.width > 600 && this.width < 676) return 170 - this.pageYOffset;
      if (this.width <= 600) return ((this.width / 2) + 120) - this.pageYOffset;
      return 150 - this.pageYOffset;
    },
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
    offset() {
      if (this.isImage(this.selectedCat, 'webpage-itemlist-banner')) return 270;
      return 50;
    },
  },
  methods: {
    isImage(item, label) {
      return !!(item.images && item.images.filter(x => x.label === label).length > 0);
    },
    runOnScroll() {
      this.pageYOffset = window.pageYOffset;
    },
    init() {
      if (this.$route.query && this.$route.query.webShopResourceId) {
        localStorage.webShopResourceId = this.$route.query.webShopResourceId;
      }
      this.$webHelper.post('catalog/getcatalog',
        {
          webShopResourceId: localStorage.webShopResourceId || this.$route.query.webShopResourceId,
          view: 'webpage',
        }, this.$router)
        .then((res) => {
          if (!res.success) {
            this.err = this.$lang.errors.failedCastalog;
            return;
          }
          this.catalogItems = res.body.catalog.itemsList;
          this.loaded = true;
        });
    },
  },
  created() {
    if (localStorage.webShopResourceId) {
      this.init();
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.runOnScroll);
  },
  mounted() {
    window.addEventListener('scroll', this.runOnScroll, { passive: true });
  },
};
</script>

<style lang="scss">
.v-alert {
  border: unset !important;
}

h2 {
  font-size: 18px;
  font-weight: 500;
}

.section {
  height: auto;
  position: relative;
}

.categories {
  padding: 24px;
  margin-bottom: 16px;
}

.shopping-basket {

}

.my-btn {
  width: 24px !important;
  height: 24px !important;
  min-width: 10px !important;
}

@media only screen and (max-width: 992px) {
  .categories,
  .shopping-basket {
    width: 100%;
    max-width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .categories {
    padding: 0;
  }
}

#vCardId {
  overflow: unset !important;
}

.v-alert .v-alert__icon.v-icon, .v-alert__dismissible .v-icon {
  align-self: start !important;
  padding-top: 2px;
}

.notifications {
  font-size: 26px;
  a {
    display: inline-block;
    float: left;
    line-height: 30px;
    position: relative;
    top: 8px;
  }
}

.side-menu {
  position: fixed;
  right: 20px;
  max-width: 135px !important;
}

@media only screen and (min-width: 960px) {
  .scrolling-wrapper {
    display: none;
  }
}

@media only screen and (max-width: 959px) {
  .side-menu {
    display: none;
  }

  .scrolling-wrapper {
    position: fixed;
    z-index: 100999;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    height: 42px;
    align-content: center;
    width: 100vw;
    -ms-overflow-style: none;
    -webkit-overflow-scrolling: touch;
    padding-top: 9px;
    margin-left: -10px;
    //-webkit-box-shadow: 0px 5px 5px 0px rgba(209, 209, 209, 1);
    //-moz-box-shadow: 0px 5px 5px 0px rgba(209, 209, 209, 1);
    //box-shadow: 0px 5px 5px 0px rgba(209, 209, 209, 1);
  }
  .scrolling-wrapper::-webkit-scrollbar {
    display: none;
  }

  h3 {
    margin: 0 !important;
  }
}

.cursorHand {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/webshop/Menu.vue